import { getBaseUrl } from 'config'

const dashboard = 'dashboard'
const exchange = 'exchange'
const finance = 'finance'
const member = 'members'
const favorite = 'favorite'
const peopleSection = 'peopleSection'
const pharmacy = 'pharmacy'
const role = 'role'
const user = 'user'
const drug = 'drug'
const category = 'category'
const message = 'message'
const review = 'review'
const pack = 'pack'
const exchangemanagement = 'exchangemanagement'
const jobSearch = 'job-search'
const prescription = 'prescription'
const job = 'job'
const fda = `/${dashboard}/fda`
const error = `/${dashboard}/error`
const reports = `/${dashboard}/reports`
const commisionSettings = 'settingsCommision'
const employmentApplication = 'employmentApplication'

const pharmacyRoutes = {
  pharmacyMessage: `/${dashboard}/${pharmacy}/messages`,
  surveyList: `/${dashboard}/${pharmacy}/surveyList`,
  aPharmacyDocs: `/${dashboard}/${pharmacy}/current-pharmacy-docs`,
  pharmacySubscriptions: `/${dashboard}/${pharmacy}/subscriptions`,
}

export default {
  defaultPath: `/${dashboard}/${exchange}/transfer?&step=1`,
  defaultPathForEndUser: `/${dashboard}`,
  login: '/login',
  loginNew: '/loginNew',
  loginPharmacy: '/loginPharmacy',
  forgetPasswordPharmacy: '/forgetPasswordPharmacy',
  forgetPasswordNew: '/forgetPasswordNew',
  otpPharmacy: '/otpPharmacy',
  otpNew: '/otpNew',
  registerPharmacyWithUser: `/register-pharmacy-with-user`,
  forgetPassword: '/forget-password',
  otp: '/otp',
  startQrcode: '/startbyqrcode',

  employmentApplicationForAdmin: `/${dashboard}/${employmentApplication}/list`,

  dashboard: `/${dashboard}`,
  desktop: `/${dashboard}/${exchange}/desktop`,
  transfer: `/${dashboard}/${exchange}/transfer`,
  transferWithFavorites: `/${dashboard}/${exchange}/transfer?faves=true`,
  survey: `/${dashboard}/${exchange}/survey`,
  supplyList: `/${dashboard}/${exchange}/supply-list`,
  suggestDrug: `/${dashboard}/${exchange}/suggest-drug`,

  transactions: `/${dashboard}/${finance}/transactions`,
  accountingInfo: `/${dashboard}/${finance}/accountingInfo`,
  membersList: `/${dashboard}/${member}/members-list`,
  drugFavoriteList: `/${dashboard}/${favorite}/drug`,

  prescription: `/${dashboard}/${peopleSection}/prescription`,
  jobApplication: `/${dashboard}/${peopleSection}/employmentApplication`,
  findJob: `/${dashboard}/${peopleSection}/findJob`,
  addTransaction: `/${dashboard}/${peopleSection}/addTransaction`,

  drugCategoryfavoriteList: `/${dashboard}/${favorite}/drug-category`,

  createPharmacy: `/${dashboard}/${pharmacy}/create`,
  pharmaciesList: `/${dashboard}/${pharmacy}/list`,
  pharmacyUsersList: `/${dashboard}/${pharmacy}/users`,
  pharmacyDocs: `/${dashboard}/${pharmacy}/docs`,
  pharmacyProfile: `/${dashboard}/${pharmacy}/profile`,

  membershipRequests: `/${dashboard}/${pharmacy}/membership-requests`,
  memberRole: `/${dashboard}/${pharmacy}/member-role`,

  createRole: `/${dashboard}/${role}/create`,

  createUser: `/${dashboard}/${user}/create`,
  usersList: `/${dashboard}/${user}/list`,
  userSubscriptions: `/${dashboard}/${user}/subscriptions`,
  userTransactions: `/${dashboard}/${user}/transactions`,

  changeUserPassword: `/${dashboard}/${user}/change-user-password`,

  createDrug: `/${dashboard}/${drug}/create`,
  drugsList: `/${dashboard}/${drug}/list`,

  categoryList: `/${dashboard}/${category}/list`,

  createMessage: `/${dashboard}/${message}/create`,
  messagesList: `/${dashboard}/${message}/list`,

  reviewsList: `/${dashboard}/${review}/list`,

  packsList: `/${pack}/list`,
  createPack: `/${pack}/create`,

  exchangeManagementList: `/${dashboard}/${exchangemanagement}/list`,

  jobSearchList: `/${dashboard}/${jobSearch}/list`,

  prescriptionList: `/${dashboard}/${prescription}/list`,

  fileUrl: `${getBaseUrl()}/File/GetFile?key=`,

  profile: `/${dashboard}/${user}/profile`,
  settings: `/${dashboard}/site-settings`,
  settingsAi: `/${dashboard}/settingsAi`,
  surplusDrugs: `/${dashboard}/surplusDrugs`,
  favoriteDrugs: `/${dashboard}/favorite-drugs`,
  allFavoriteList: `/${dashboard}/${favorite}/favorite-list`,
  selectedDrugs: `/${dashboard}/selectedDrugs`,
  jobsList: `/${dashboard}/${job}/list`,
  commisionSettingsList: `/${dashboard}/${commisionSettings}/list`,

  ...pharmacyRoutes,

  fda_exchangeList: `${fda}/exchange-list`,

  error401: `${error}/401`,

  loginCountReport: `${reports}/login-count`,
  allPharmacyDrugReport: `${reports}/all-pharmacy-drugs`,
  acceptedPrescriptionsReport: `${reports}/accepted-prescriptions`,
  allEmploymentApplicationsReport: `${reports}/all-employment-applications`,
  allAccountingReport: `${reports}/all-acounting-report`,
  allAccountingFullReport: `${reports}/all-acounting-full-report`,
  allPharmacyWithSurplusDrugsReport: `${reports}/all-pharmacy-with-surplus-drugs`,
  allSubscriptionReport: `${reports}/all-subscriptions`,
  allSubscriptionUserReport: `${reports}/all-users-subscriptions`,
  ostanRankingReport: `${reports}/ostan-ranking-report`,
  allPacksReport: `${reports}/all-packs-report`,

  addSubscription: `/${dashboard}/subscription/add-subscription`,
  addSubscriptionForUser: `/${dashboard}/subscription/add-subscription-for-user`,
  addUserSubscription: `/${dashboard}/${peopleSection}/add-subscription`,
  manageSubscriptions: `/${dashboard}/subscription/subscriptions`,
  subscriptionList: `/${dashboard}/subscription/subscription-list`,
  manageUserSubscriptions: `/${dashboard}/subscription/userSubscriptions`,
  subscriptionUserList: `/${dashboard}/${peopleSection}/subscription-list`,

  declarationsList: `/${dashboard}/declaration/list`,

  about: `/${dashboard}/about`,
  pharmacyDrugHistoryReport: `${reports}/pharmacy-drug-history`,
}
